import type { AccountError } from '@/graphql/saleor/api';
import * as M from '@/messages/myAccount';

import type { FormattedError } from './common';

export const getAccountSignInErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'UNIQUE':
      return M.myAccountMessages.accountAlreadyExist;
    default:
      return M.myAccountMessages.invalidCredentials;
  }
};
